// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16t9t","top":"styles_top__1dP_v"};